import { render, staticRenderFns } from "./ModalCancelarMonitoramentos.vue?vue&type=template&id=6f891e98&lang=pug"
import script from "./ModalCancelarMonitoramentos.vue?vue&type=script&lang=js"
export * from "./ModalCancelarMonitoramentos.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelarMonitoramentos.vue?vue&type=style&index=0&id=6f891e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports